export const GantColorColumn = [
   "Item",
   "Style",
   "ColorCode",
   "MovexColorName",
  ]